/* Luvlyn · de shoppagina (/collections/vogelgeluiden-wc; ontwerp: vogelgeluiden-wc.html en js/wc.js).
   Alleen wat deze pagina extra doet. Het geluid, het mandje, de chat (ook een vraag uit een link, #kleine-wc)
   en de bezorgdatum doet assets/site.js.
   1. Draaien: op een scherm zonder muis bestaat "aanwijzen" niet. Daar staat op de foto een knopje
      dat het schuinaanzicht laat zien, en weer terug.
   2. De inhoudsopgave van de tekst: de vraag die je leest, licht op. IntersectionObserver, geen
      scroll-listener. */
(() => {
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];

  /* ---------- 1. draaien op een aanraakscherm ---------- */
  const aanraak = matchMedia('(hover: none)');
  const zetKnoppen = () => $$('[data-draai]').forEach(b => { b.hidden = !aanraak.matches; });
  zetKnoppen();
  aanraak.addEventListener('change', zetKnoppen);
  document.addEventListener('click', e => {
    const knop = e.target.closest('[data-draai]'); if (!knop) return;
    const doel = knop.closest('[data-draai-doel]'); if (!doel) return;
    const aan = doel.classList.toggle('wc-schuin-aan');
    knop.setAttribute('aria-pressed', String(aan));
  });

  /* ---------- 2. de inhoudsopgave die meeloopt ---------- */
  $$('[data-inhoud]').forEach(nav => {
    const links = $$('a[href^="#"]', nav);
    const koppen = links.map(a => document.getElementById(a.getAttribute('href').slice(1))).filter(Boolean);
    const zet = id => links.forEach(a => {
      if (a.getAttribute('href') === `#${id}`) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    });
    links.forEach(a => a.addEventListener('click', () => zet(a.getAttribute('href').slice(1))));
    if (!koppen.length || !('IntersectionObserver' in window)) return;
    // een smalle band boven in beeld, onder de kop die meeloopt: de kop die daar doorheen gaat, is de vraag die je leest
    const io = new IntersectionObserver(items => items.forEach(item => { if (item.isIntersecting) zet(item.target.id); }),
      { rootMargin: '-110px 0px -62% 0px' });
    koppen.forEach(k => io.observe(k));
  });
})();
